<template>
    <div id="timelineSlider" @mouseover="isScrolling = true">
      <div id='timelineSliderBall' :class="{ animate: isPlaying }" :style="{ left: sliderPosition }">
        <transition name="fade">
          <div v-if="isScrolling" class="popup">{{ currentYear }}</div>
        </transition>
      </div>
      <div class="segmentContainer" id="segmentContainer">
        <Segment v-for="(d, index) in districts"
                :key="'segment_' + index"
                :id="'segment_' + d.properties.endYear"
                :containerWidth="containerWidth"
                :startYear="d.properties.startYear"
                :endYear="d.properties.endYear"
                :currentYear="currentYear"
                :totalTimelineSpan="totalTimelineSpan"
                :stop="stop"
                :updateYear="updateYear"></Segment>
      </div>
    </div>
</template>

<script>
  import Segment from './Segment';

  export default {
    name: 'Timeline',
    components: {
      Segment
    },
    props: ['districts', 'currentDistrict',
            'currentYear', 'totalTimelineSpan',
            'isPlaying', 'stop', 'updateYear'],
    data () {
      return {
        containerWidth: 0,
        sliderPosition: 15,
        isScrolling: false,
        popupTimeout: null,
      }
    },
    methods: {
      handleWindowResize () {
        if (document && document.getElementById('timelineSlider')) {
          this.$nextTick(function () {
            this.containerWidth = document.getElementById('segmentContainer').offsetWidth;
            this.updateSliderPosition();
          });
        }
      },
      updateSliderPosition () {
        // get relative position within current year span
        const spanEl = document.getElementById('segment_' + this.currentYearSpan.end);
        const initialOffset = spanEl.offsetLeft;
        const spanWidth = spanEl.offsetWidth;
        const spanYears = this.currentYearSpan.end - this.currentYearSpan.start + 1;

        const newPosition = initialOffset + ((this.currentYearSpan.end - this.currentYear) / spanYears * spanWidth);

        this.sliderPosition = newPosition + 'px';
      },
      setPopupTimeout () {
        const vm = this;

        if(this.popupTimeout) {
          clearTimeout(vm.popupTimeout);
        }

        // Hide popup after 4 seconds
        this.popupTimeout = setTimeout(function(){ vm.isScrolling = false; }, 4000);
      }
    },
    computed: {
      currentYearSpan () {
        return {
          start: this.currentDistrict.properties.startYear,
          end: this.currentDistrict.properties.endYear,
        }
      }
    },
    watch: {
      currentYear (newVal) {
        this.updateSliderPosition();
        this.setPopupTimeout();
        this.isScrolling = true;
      },
      isScrolling (newVal) {
        if (newVal) {
          this.setPopupTimeout();
        }
      }
    },
    mounted: function () {
      // Check for changes in timeline width on resize
      window.addEventListener('resize', this.handleWindowResize);
      this.handleWindowResize();
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

#timelineSlider {
  width: 65vw;
  padding: 0 1.5rem;
  height: $tinelineContainerHeight;
  background-color: $darkBackgroundColor;
}

#timelineSliderBall {
  position: absolute;
  top: 30px;
  display: block;
}
.animate {
  transition: left 0.25s; // Animation timing (match with animationDuration on ScrollyMap)
  transition-timing-function: linear;
}
.segmentContainer {
  display: flex;
  align-items: center;
  margin-top: 15px;
  width: 100%;
  box-sizing: border-box;
}

.popup {
  font-size: 0.72rem;
  letter-spacing: 0.2px;
  font-weight: bold;
  background: white;
  color: $darkTextColor;
  width: 36px;
  text-align: center;
  border-radius: 3px;
  position: absolute;
  bottom: 19px;
  left: -21px;
  padding: 3px;
  box-shadow: $boxShadow;
  z-index: 1000;
}
.popup:after {
  content: '';
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #fff;
  position: absolute;
  bottom: -5px;
  left: 16px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* Mobile view (<900px wide) */
.mq-mobile {
  .mobileButtonContainer {
    position: fixed;
    bottom: 24vh;
    left: 15px;
    background: $darkBackgroundColor;
  }
  #timelineSliderBall {
    top: 28px;
  }
  #timelineSlider {
    // width: 85vw;
    width: 100%
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Timeline.vue